if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;

        // confirmation modal
        this.confirmModalId = this.getAttribute("data-modal-confirmation");

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.quizActButton = this.getAttribute("target-quiz");

        //store dog and your information
        this.dogInformation = {
          currentStep: 0,
          totalStep: 6,
          lastCompletedStep: 0,
          isDogHealthy: false,
          progress: 0,
          isQualifyForQuizProduct: false,
          dogInfo: {
            name: "",
            gender: "",
            ageYrs: "",
            ageMonths: "",
            weight: "1-10 lbs",
            health: "",
            activity: "",
            healthIssue: false,
            multiSelect: [],
            dogBreed: "",
          },
          yourInfo: {
            yourName: "",
            email: "",
          },
        };

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        // Define the static product ID you want to check
        this.staticProductIdToCheck = '39975568605250';
      }

      //waitFor Datalayer
      onDataHelperLoad(callback) {
        var intervalId = setInterval(function() {
          if (typeof window.dataLayer != "undefined") {
            clearInterval(intervalId);
            callback();
          }
        }, 30);
        setTimeout(function() {
          clearInterval(intervalId);
        }, 15000);
      }
      //ga events
      trackGAEvent(eventCategory, eventAction, eventLabel) {
        if ("ga" in window && "getAll" in window.ga) {
          ga.getAll()[0].send("event", {
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: eventLabel,
          });
        }
      }
      //ger selected variant
      getSelectedVariant(prod_id) {
        var prodSku = "";
        if (meta && meta.product) {
          var variant = meta.product.variants.filter(function(variant) {
            return variant.id == prod_id;
          });

          if (variant.length > 0) {
            prodSku = variant[0].sku;
          }
        }
        return prodSku;
      }
      //infoplus order lineitem
      updateOrderLine(prodSku) {
        var newInventory = document.getElementById("newInverntoryData");
        if (!newInventory) return "";

        //convert in json format
        newInventory = JSON.parse(newInventory.innerText);

        // loop through line items
        let infoProdDetail = newInventory.filter(function(item) {
          return item.skuShopify == prodSku;
        });
        let quantity = 1;
        let infoSku = "";

        console.log(infoProdDetail, prodSku);
        if (infoProdDetail.length > 0) {
          infoSku = infoProdDetail[0]["infoPlusSku"];
          quantity = infoProdDetail[0]["quantity"] || 1;
        }

        infoSku = infoSku || "";

        return {
          infoSku,
          quantity
        };
      }
      checkDietOptions(formData, numOptions) {
        // Array to store the property keys dynamically
        const dietOptionKeys = [];

        // Populate the dietOptionKeys array with dynamic keys
        for (let i = 1; i <= numOptions; i++) {
          dietOptionKeys.push(`Diet Option ${i}`);
        }

        // Loop through each property key and check if it's set and not empty
        for (const key of dietOptionKeys) {
          const value = formData.get(`properties[${key}]`);
          if (!value || value.trim() === '') {
            // If any property is not set or empty, return false
            return false;
          }
        }

        // If all properties are set and not empty, return true
        return true;
      }
      // Function to scroll to a specific section based on its selector
      scrollToSection(Selector) {
        $('html, body').animate({
          scrollTop: $(Selector).offset().top
        }, 1000);
      }

      // --- Function to check if a product is in the cart ---
     async checkIfProductInCart(productId) {
     console.log(`[checkIfProductInCart] Checking for product ID: ${productId}`);
     try {
     // Ensure routes.cart_url is correctly defined and accessible globally
     if (typeof routes === 'undefined' || !routes.cart_url) {
      console.error("[checkIfProductInCart] 'routes.cart_url' is not defined. Cannot check cart.");
      return false;
     }

     const response = await fetch(`${routes.cart_url}.js`);
     if (!response.ok) {
      console.error(`[checkIfProductInCart] Failed to fetch cart: ${response.status} ${response.statusText}`);
      return false;
     }
     const cart = await response.json();
     console.log("[checkIfProductInCart] Current cart contents:", cart);

     const foundInCart = cart.items.some(item => {
      const isIn = String(item.variant_id) === String(productId);
      if (isIn) {
        console.log(`[checkIfProductInCart] Variant ID ${productId} found in cart. Item:`, item);
      }
      return isIn;
      });

    // Update message display based on whether product is in cart
       const defaultMsg = document.querySelector('.default-message');
      const inCartMsg = document.querySelector('.in-cart-message');
      if (defaultMsg && inCartMsg) {
      if (foundInCart) {
        defaultMsg.style.display = 'none';
        inCartMsg.style.display = 'block';
      } else {
        defaultMsg.style.display = 'block';
        inCartMsg.style.display = 'none';
       }
      }

      if (!foundInCart) {
      console.log(`[checkIfProductInCart] Variant ID ${productId} NOT found in cart.`);
      }
      return foundInCart;
      } catch (error) {
     console.error("[checkIfProductInCart] Error checking cart:", error);
      return false; // Assume not in cart on error
       }
      }

      async onSubmitHandler(evt) { // Made onSubmitHandler async
        evt.preventDefault();
        console.log("[onSubmitHandler] Submit button clicked.");

        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          console.log("[onSubmitHandler] Submit button is disabled, returning.");
          return;
        }

        var dogName = document.querySelector("#your-dogs-name");
        if (!this.quizActButton && dogName && dogName.value == "") {
          var dogNameError = document.querySelector(".dogName_error");
          dogNameError && (dogNameError.style.display = "block");
          console.log("[onSubmitHandler] Dog name is empty, showing error and returning.");
          return;
        }

        var dogNameError = document.querySelector(".dogName_error");
        dogNameError && (dogNameError.style.display = "none");

        this.handleErrorMessage(); // Clear previous errors

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        console.log("[onSubmitHandler] Submit button set to loading state.");


        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const currentVariantId = formData.get("id");
        console.log(`[onSubmitHandler] Form submitted variant ID: ${currentVariantId}`);
        console.log(`[onSubmitHandler] Static variant ID to check: ${this.staticProductIdToCheck}`);


        // --- Start of new logic for specific variant ID check ---
        // Ensure strict equality, converting to string to be safe.
        if (String(currentVariantId) === String(this.staticProductIdToCheck)) {
        console.log(`[onSubmitHandler] Matching variant ID ${currentVariantId}. Checking if already in cart...`);
        const isInCart = await this.checkIfProductInCart(this.staticProductIdToCheck);
        if (isInCart) {
       console.log("[onSubmitHandler] Product already in cart. Preventing add to cart.");
       this.submitButton.removeAttribute("aria-disabled");
       this.submitButton.classList.remove("loading");
       this.querySelector(".loading-overlay__spinner").classList.add("hidden");
       return; // Stop the function here
       } else {
       console.log("[onSubmitHandler] Product NOT in cart. Proceeding with add to cart.");
       }
       } else {
          console.log(`[onSubmitHandler] Variant ID ${currentVariantId} does not match static ID ${this.staticProductIdToCheck}. Skipping cart check for this product.`);
        }
        // --- End of new logic for specific variant ID check ---

        //check if diet options are set AND not empty
        $('.sample-select-all-error-msg').remove();

        if (formData.get('product-id') == '6811261894722' && !this.checkDietOptions(formData, 5)) {
          console.log("[onSubmitHandler] Diet options not fully selected for product 6811261894722, showing error.");
          // this.scrollToSection('.sample-select-all');
          var newElement = $('<div class="sample-select-all-error-msg"><p>You should select all items to proceed.</p></div>');
          newElement.insertBefore('.product-form__buttons');
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.classList.remove("loading");
          this.querySelector(".loading-overlay__spinner").classList.add("hidden");

          return;
        }
        var confirmModal = document.querySelector("add-more-confirmation");


        // Update quiz page properties
        var _this = this;
        if (_this.quizActButton) {
          var dogInfomation = localStorage.getItem("dogInformation");
          dogInfomation = dogInfomation && JSON.parse(dogInfomation);
          Object.assign(this.dogInformation, dogInfomation);

          formData.set("properties[Dog's Age In Month]", this.dogInformation.dogInfo.ageMonths);
          formData.set("properties[Dog's Age In Year]", this.dogInformation.dogInfo.ageYrs);
          formData.set("properties[Dog's Activity]", this.dogInformation.dogInfo.activity);
          formData.set("properties[Dog's Gender]", this.dogInformation.dogInfo.gender);
          formData.set("properties[Dog's Breed]", this.dogInformation.dogInfo.dogBreed);
          formData.set("properties[Health Issue]", this.dogInformation.dogInfo.healthIssue);
          formData.set("properties[MultiSelect]", this.dogInformation.dogInfo.multiSelect);
          formData.set("properties[Your Name]", this.dogInformation.yourInfo.yourName);
          formData.set("properties[Your Email]", this.dogInformation.yourInfo.email);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        console.log("[onSubmitHandler] Final config body (before fetch):", config.body);
        const isGoatMilkAddon = $('.goatMilkAddToOrder:checked').val();
        console.log("[onSubmitHandler] isGoatMilkAddon:", isGoatMilkAddon);

        if (isGoatMilkAddon == 'on') {
          const product_id = formData.get("id");
          // Delete the original key-value pair
          formData.delete("product-id");
          formData.delete("id");
          //formData
          // Add the new key-value pair
          formData.append("items[0][id]", product_id);
          formData.append("items[1][id]", "40423514046530");

          formData.append("items[0][properties][Diet Option 1]", formData.get("properties[Diet Option 1]"));
          formData.append("items[0][properties][Diet Option 2]", formData.get("properties[Diet Option 2]"));
          formData.append("items[0][properties][Diet Option 3]", formData.get("properties[Diet Option 3]"));
          formData.append("items[0][properties][Diet Option 4]", formData.get("properties[Diet Option 4]"));
          formData.append("items[0][properties][Diet Option 5]", formData.get("properties[Diet Option 5]"));
        }

        console.log("[onSubmitHandler] Attempting to fetch to cart_add_url...");
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log("[onSubmitHandler] Add to cart response:", response);
            if (response.status) {
              this.handleErrorMessage(response.description);
              console.log("[onSubmitHandler] Error in add to cart response:", response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              console.log("[onSubmitHandler] Cart object not found, redirecting to cart page.");
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                }, {
                  once: true
                }
              );
              quickAddModal.hide(true);
              console.log("[onSubmitHandler] Quick add modal detected, rendering cart contents.");
            } else {
              if (this.confirmModalId) {
                this.cart.onlyRenderContents(response);
                document.querySelector('cart-drawer').open();
                console.log("[onSubmitHandler] Confirmation modal detected, opening cart drawer.");
              } else {
                this.cart.renderContents(response);
                console.log("[onSubmitHandler] No quick add or confirmation modal, rendering cart contents normally.");
              }
            }
          })
          .catch((e) => {
            console.error("[onSubmitHandler] Fetch error during add to cart:", e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            console.log("[onSubmitHandler] Submit button loading state removed.");

            //fire ga
            if (_this.quizActButton) {
              var dogInfomation = localStorage.getItem("dogInformation");
              dogInfomation = dogInfomation && JSON.parse(dogInfomation);
              _this.onDataHelperLoad(function() {
                dataLayer.push({
                  event: "Quiz Form Step",
                  stepCount: "Final Step",
                  stepInfo: dogInfomation.dogInformation,
                });
              });

              //ga
              var label = "Final Step Completed";
              _this.trackGAEvent("Quiz_Form_Step", "Step", label);

              //add upsell form
              var upsellForm = document.querySelector('product-form.upsell_form [type="submit"]');
              if (upsellForm && document.querySelector('.custom-selected-diet .variety-box[diet-type="bag"]')) {
                upsellForm.click();
              }
            }
          });
      }

      closeYouMayAlsoLikePopup() {
        this.bodyElm.classList.remove('show-you-may-also-like-popup');
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get('you-may-also-like-popup')) {
  class YouMayAlsoLikePopup extends HTMLElement {
    constructor() {
      super();
      this.bodyElm = document.querySelector('body');
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.parent_selling_plan = '';
      var _this = this;

      this.querySelector('.goatMilkAddToOrder')?.addEventListener('change', function (e) {
        // Check if the "Add to order" checkbox is checked

        if (this.checked) {
          var parent = _this.querySelector('.umalFireDietBottom');
          var product_id = parent.getAttribute('data-recommendedProductId');
          var variant_id = parent.getAttribute('data-recommendedProductVarId');
          var hiddenInput1 = document.createElement('input');
          hiddenInput1.type = 'hidden';
          hiddenInput1.name = 'product-id'; // Set the name attribute
          hiddenInput1.value = product_id; // Set the value attribute
          _this.form.appendChild(hiddenInput1);
          var hiddenInput2 = document.createElement('input');
          hiddenInput2.type = 'hidden';
          hiddenInput2.name = 'id'; // Set the name attribute
          hiddenInput2.value = variant_id; // Set the value attribute
          _this.form.appendChild(hiddenInput2);
          if (_this.querySelector('[name="recommendedProductFreq"]:checked').value === '1') {
            _this.appendSellingPlan();
          }
        } else {
          _this.form.querySelector('[name="id"]')?.remove();
          _this.form.querySelector('[name="product-id"]')?.remove();
          _this.form.querySelector('[name="selling_plan"]')?.remove();
        }
      });

      // this.querySelectorAll('[name="recommendedProductFreq"]')?.addEventListener('change', function (e) {
      //   console.log(e)
      //   if(e.target.checked && e.target.value === "1"){
      //     console.log('lklklklklk')
      //   }else{
      //     console.log('nmnmnmnm')
      //   }
      // })

      this.querySelectorAll('[name="recommendedProductFreq"]').forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          var addToOrderCheckbox = _this.querySelector('.goatMilkAddToOrder');

          if (e.target.checked && e.target.value === '1' && addToOrderCheckbox.checked) {
            _this.appendSellingPlan();
          } else {
            _this.form.querySelector('[name="selling_plan"]')?.remove();
          }
        });
      });

      // Click on the "Next" button
      // this.querySelector('.next-btn')?.addEventListener('click', function (e) {
      //   e.preventDefault();
      //   _this.closeYouMayAlsoLikePopup();
      //   _this.openAddMoreConfirmation();
      //     // Check if the "Add to order" checkbox is checked
      //     var addToOrderCheckbox = _this.querySelector('.goatMilkAddToOrder');
      //     if (addToOrderCheckbox && addToOrderCheckbox.checked) {
      //       // Get the data attribute of the parent element
      //       var recommendedProductId = addToOrderCheckbox.closest('[data-recommendedProductId]').getAttribute('data-recommendedProductId');
      //       var recommendedProductFreq = _this.querySelector('[name="recommendedProductFreq"]:checked').value;
      //       if(recommendedProductId && recommendedProductFreq){
      //         var item = {
      //           id: recommendedProductId,
      //           qty: 1
      //         }
      //         if(recommendedProductFreq == '1'){
      //           item.selling_plan = document.querySelector('[name="Delivery_every_1_Week"]').value
      //         }
      //         // Call a function to add the product to the cart
      //          _this.addToCart(item);
      //       }
      //     }
      // });
    }

    appendSellingPlan() {
      // Get the select element
      var selectElement = document.getElementById('recommended_product_selling_plans');

      // Loop through options to find the one with the matching data-plan-option
      for (var i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].getAttribute('data-plan-option') === this.parent_selling_plan) {
          // Create a hidden input element
          var hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'selling_plan'; // Set the name attribute
          hiddenInput.value = selectElement.options[i].value; // Set the value attribute
          this.form.appendChild(hiddenInput);
          break;
        }
      }
    }

    //on form submit handler
    onSubmitHandler(evt) {
      evt.preventDefault();

      console.log('on you may also like popup submit add to cart');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
      // Get Add on is every order or one time
      const addOnType = $('input[name="recommendedProductFreq"]:checked').val();
      // console.log(addOnType);
      if (addOnType == 1) {
        this.processAddonWhenEveryOrder(config);
      } else {
        console.log(config);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            this.cart.onlyRenderContents(response);
          });
        console.log("closeYouMayAlsoLikePopup")
        this.closeYouMayAlsoLikePopup();
        this.openAddMoreConfirmation();
      }
    }

    async processAddonWhenEveryOrder(config) {
      //add Loader
      jQuery('#scrollBar').append(`
        <div class="loadingElement" style="
          position: absolute;
          inset: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #00000029;
      ">
                <p style="
          color: white;
          font-size: 20px;
          letter-spacing: 2px;
      ">Adding Please Wait...</p>
            </div>
        `)
      var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((data) => {
          return data;
        });

      //get current variation option selected by user
      const variationOption = cartContents.items[0].variant_options;
      const currentCartItemHandle = cartContents.items[0].handle;
      const sellingPlanIds = {
        earth_diet: 6741196866,
        fire_diet: 6740934722,
        metal_diet: 6741327938,
        water_diet: 6740836418,
        wood_diet: 6748635202,
      };
      // console.log(currentCartItemHandle);
      // console.log(window.bundleVariation.products)
      //GetProductBunlde of current product
      const currentProductBundle = this.getObjectByHandle(currentCartItemHandle, window.bundleVariation.products);

      //Get current varaition object of bundle product selected by user as simple product
      const currentProductBundleVariationObject = this.getObjectByOptionValues(
        variationOption,
        currentProductBundle.variants
      );

      //Get cart item actual price
      const currentCartItemPrice = cartContents.items[0].final_line_price;

      //Get Bundle Variation Price
      const bundleVariationPrice = currentProductBundleVariationObject.prices[0].unit_price;

      //Get Goat milk price and qty for set property of bundle product cart item
      const goatMilkQtyAndPrice = this.getGoatMilkPriceAndQty(currentCartItemPrice, bundleVariationPrice);
      console.log(goatMilkQtyAndPrice)
      // Create bundle selection object
      // we'll pass this object to `getBundleId`.
      const bundle = {
        externalVariantId: currentProductBundleVariationObject.external_variant_id,
        externalProductId: currentProductBundleVariationObject.external_product_id,
        selections: [],
      };

      //Check created bundle is valid of not
      const isValid = await recharge.bundle.validateBundle(bundle);

      if (isValid) {
        const rbId = await recharge.bundle.getBundleId(bundle);
        const handle = currentCartItemHandle.replace(/-/g, '_');
        // Adds the value directly to the cart
        const cartData = {
          items: [
            {
              id: currentProductBundleVariationObject.external_variant_id,
              quantity: 1,
              selling_plan: sellingPlanIds[handle],
              properties: {
                _rb_id: rbId,
                Contents: `1x ${cartContents.items[0].title} Price: $${currentCartItemPrice / 100}  + ${goatMilkQtyAndPrice.GoatMilkQty
                  }x Goat Milk Price: $${goatMilkQtyAndPrice.goatMilkTotalPrice} `,
              },
            },
          ],
        };

        //add bundle product
        await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartData),
        });

        //remove previously added product
        var updates = {};
        updates[cartContents.items[0].variant_id] = 0;

        await fetch(routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
        this.closeYouMayAlsoLikePopup();
        this.openAddMoreConfirmation();
      }
    }

    /**
     * Get Goat milk product price and qty
     */
    getGoatMilkPriceAndQty(currentCartItemPrice, bundleVariationPrice) {
      console.log(parseInt(currentCartItemPrice), parseFloat(bundleVariationPrice) * 100);
      const goatMilkPrice = 8;
      const goatMilkTotalPrice = Math.round((parseFloat(bundleVariationPrice) * 100 - currentCartItemPrice) / 100);
      const GoatMilkQty = Math.round(goatMilkTotalPrice / (goatMilkPrice));

      return {
        goatMilkPrice,
        GoatMilkQty,
        goatMilkTotalPrice,
      };
    }

    /**
     * Get product object by passing handle and array of products
     */
    getObjectByHandle(handle, arrayOfObjects) {
      // Find the object with the matching handle
      const foundObject = arrayOfObjects.find((obj) => obj.handle.includes(handle));

      return foundObject || null; // Return the found object or null if not found
    }

    /**
     * Get variation object by passing option_value array and array of products
     */
    getObjectByOptionValues(optionValues, arrayOfObjects) {
      // Find the object with matching option values
      const foundObject = arrayOfObjects.find((obj) =>
        optionValues.every((value) => obj.option_values.includes(value))
      );

      return foundObject || null; // Return the found object or null if not found
    }
    open(response) {
      var selling_plan_name = response.selling_plan_allocation.selling_plan.name;
      this.parent_selling_plan = selling_plan_name;
      const varientBox = $('.custom-selected-diet').children().length
      if (varientBox > 1) {
        $('#button1 , label[for="button1"]').hide()
      }
      this.bodyElm.classList.add('show-you-may-also-like-popup');
      var youMayAlsoLikePopup = document.querySelector('.youMayAlsoLikePopup');

      // Scroll to the top of the 'youMayAlsoLikePopup' element with smooth behavior
      youMayAlsoLikePopup.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    closeYouMayAlsoLikePopup() {
      this.bodyElm.classList.remove('show-you-may-also-like-popup');
    }

    openAddMoreConfirmation() {
      var addMoreConfirmation = document.querySelector('add-more-confirmation');
      addMoreConfirmation?.open();
    }

    addToCart(item) {
      var _this = this;
      console.log('add to cart');
      var items = [];
      items.push(item);
      return $.post('/cart/add.json', {
        items: items,
      })
        .done(function (data, textStatus, jqXHR) {
          console.log(data);
          _this.cart.onlyRenderContents(data.items[0]);
          console.log('done');
          // window.location.href = "/checkout";
        })
        .fail(function (jqXHR, textStatus) {
          // alert(jqXHR.responseJSON.errors+' : Store doesn\'t have enough stock yet for the product which you want.')
          console.log('Error - ajax update quantity', jqXHR.responseJSON.errors);
        });
    }
  }

  customElements.define('you-may-also-like-popup', YouMayAlsoLikePopup);
}